<modal-container
  #modal
  [headerTitle]="'loggableHistory.title'"
  [headerTitleAfterTranslatedTitle]="titleSuffix()"
  [headerIconClass]="'far-history'"
  [isLargeModal]="true"
  [isLoading]="loading()"
>
  <ng-container class="modal-button-show">
    <btn
      [icon]="'far-history'"
      [label]="'loggableHistory.button'"
      [title]="'loggableHistory.button' | translate"
      [classes]="['btn-third', 'float-right', 'me-2']"
      (onEvent)="showChildModal()"
      [dataCyAttribute]="'loggable-history-show'"
    ></btn>
  </ng-container>
  <ng-container class="modal-body-content">
    @if (canGoBack()) {
      <div class="loggable-history-nav mb-3">
        <btn
          [icon]="'far-arrow-left'"
          [label]="'back'"
          [title]="'back' | translate"
          [classes]="['btn-third', 'btn-sm']"
          (onEvent)="goBack()"
          [dataCyAttribute]="'loggable-history-back'"
        ></btn>
      </div>
    }

    @if (!loading()) {
      @if (entries().length === 0) {
        <div class="text-muted">{{ 'loggableHistory.empty' | translate }}</div>
      }
      @for (entry of entries(); track entry) {
        <div
          class="card mb-2 border-0 border-start border-4 shadow-sm"
          [ngClass]="
            'border-' + (entry.action === 'create' ? 'success' : entry.action === 'delete' ? 'danger' : 'primary')
          "
        >
          <div class="card-body py-2 px-3">
            <div class="d-flex justify-content-between align-items-center flex-wrap">
              <div class="d-flex align-items-center">
                <span class="badge bg-light text-dark rounded-pill me-2">v{{ entry.version }}</span>
                <span class="badge" [ngClass]="actionBadgeClass(entry.action)">{{
                  'loggableHistory.action.' + entry.action | translate
                }}</span>
              </div>
              <div class="text-muted small text-nowrap entry-meta">
                <span class="entry-date"
                  ><i class="far fa-calendar me-1"></i>{{ entry.loggedAt | fmtDate: 'dd.MM.yyyy' }}
                  {{ entry.loggedAt | fmtDate: 'HH:mm' }}</span
                >
                <span class="entry-username">
                  @if (entry.username) {
                    <i class="far fa-user me-1"></i>{{ entry.username }}
                  }
                </span>
              </div>
            </div>
            @if (entry.changes?.length) {
              <div class="changes-grid mt-2 pt-2 border-top">
                @for (change of entry.changes; track change; let i = $index) {
                  @if (i > 0) {
                    <div class="change-divider"></div>
                  }
                  <span class="change-name">{{ change.field | translate }}</span>
                  <span class="change-value text-muted">
                    @if (canOpenHistory(change)) {
                      <a
                        class="change-value__link"
                        role="button"
                        tabindex="0"
                        [title]="'loggableHistory.openObjectHistory' | translate"
                        (click)="openRelated(change)"
                        (keydown.enter)="openRelated(change)"
                        >{{ displayValue(change) }} <i class="far fa-history ms-1"></i
                      ></a>
                    } @else {
                      {{ displayValue(change) }}
                    }
                  </span>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (hasMore()) {
        <div class="d-flex justify-content-center">
          <btn
            [label]="'loggableHistory.loadMore'"
            [icon]="'far-redo'"
            [isLoading]="loadingMore()"
            (onEvent)="loadMore()"
            [classes]="['btn-third']"
          ></btn>
        </div>
      }
    }
  </ng-container>
</modal-container>
